import React from 'react'
import { RootState } from '@/store/configureStore'
import { useDispatch, useSelector } from 'react-redux'
import { handleTrackingModal } from '@/store/reducers/modalSlice'

export const useTrackingModal = () => {
  const dispatch = useDispatch()
  const { isTrackingModalOpen, trackingNumbers } = useSelector((state: RootState) => state.modalSlice)

  const openTrackingModal = (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    trackingNumbers: TTrackingNumber[]
  ) => {
    event.preventDefault()
    dispatch(handleTrackingModal({ open: true, trackingNumbers: trackingNumbers }))
  }

  const closeTrackingModal = () => {
    dispatch(handleTrackingModal({ open: false }))
  }

  const handleEachTracking = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    event.preventDefault()
  }

  return {
    isTrackingModalOpen,
    trackingNumbers,
    openTrackingModal,
    closeTrackingModal,
    handleEachTracking
  }
}
